import { css, styled, keyframes } from '@lux/ds';

export const LuxLLogo: React.FC<{ className?: string }> = ({ className }) => (
  <svg width="14" height="18" viewBox="0 0 14 18" fill="none" className={className}>
    <path
      d="M0.620605 0.466797V4.36546V4.7388V9.01613V13.2615V17.5335H4.82925V13.2615V9.01613V4.7388V4.36546V0.466797H0.620605Z"
      fill="#131113"
    />
    <path d="M6.52246 17.5337H13.2216V13.2617L6.52246 17.5337Z" fill="#131113" />
  </svg>
);

export const LuxLogoFull: React.FC<{ className?: string }> = ({ className }) => (
  <svg width="174" height="18" viewBox="0 0 174 18" fill="none" className={className}>
    <path
      d="M30.2869 10.1388C30.2869 11.4866 29.9178 12.4845 29.1653 13.1737C28.503 13.7785 27.6681 14.0728 26.6059 14.0728C25.5467 14.0728 24.7195 13.7795 24.0772 13.1871C23.3171 12.4739 22.948 11.4712 22.948 10.1388V0.621094H19.292V10.0909C19.292 12.3273 19.9793 14.1706 21.3347 15.5663C22.7055 16.9649 24.4769 17.6761 26.605 17.6761C28.7493 17.6761 30.5284 16.9658 31.8915 15.5663C33.2489 14.1735 33.9391 12.3311 33.9391 10.0909V0.621094H30.285V10.1388H30.2869Z"
      fill="#1D1D1B"
    />
    <path
      d="M58.1681 0.621094H53.5468L49.5984 5.8348L45.6672 0.621094H41.0459L47.339 8.80927L40.6318 17.4988H45.2637L49.5984 11.7454L53.9513 17.4988H58.5764L51.8712 8.80927L58.1681 0.621094Z"
      fill="#1D1D1B"
    />
    <path
      d="M69.9837 4.42522C70.5579 4.17695 71.318 4.04946 72.2507 4.04946C73.1269 4.04946 73.8678 4.26035 74.5101 4.69554C75.1571 5.12978 75.6278 5.70301 75.9451 6.44686L76.1991 7.0431H80.0142L79.5532 5.7356C78.9847 4.13669 78.0434 2.85411 76.7426 1.92813C75.3594 0.939831 73.7164 0.439453 71.8692 0.439453C69.4152 0.439453 67.3898 1.30122 65.8388 2.99982C64.4057 4.60256 63.6743 6.64529 63.6743 9.06187C63.6743 11.4746 64.4057 13.5135 65.8445 15.1297C67.3898 16.8235 69.4162 17.6795 71.8692 17.6795C73.7183 17.6795 75.3613 17.1801 76.7378 16.1927C78.0405 15.2725 78.9847 13.9899 79.5532 12.3814L80.0142 11.0739H76.1991L75.9451 11.6711C75.6278 12.4169 75.1571 12.994 74.5063 13.4292C73.8602 13.8605 73.1221 14.0752 72.2498 14.0752C70.5914 14.0752 69.3846 13.6142 68.5449 12.6623C67.7281 11.7478 67.3294 10.5688 67.3294 9.06187C67.3294 7.55019 67.7291 6.3721 68.5439 5.45665C68.935 5.01667 69.4066 4.67925 69.9837 4.42522Z"
      fill="#1D1D1B"
    />
    <path
      d="M115.746 10.1388C115.746 11.4885 115.376 12.4845 114.625 13.1737C113.963 13.7785 113.121 14.0728 112.065 14.0728C111.004 14.0728 110.175 13.7795 109.532 13.1871C108.774 12.4739 108.404 11.4712 108.404 10.1388V0.621094H104.75V10.0909C104.75 12.3301 105.439 14.1735 106.796 15.5663C108.162 16.9649 109.932 17.6761 112.065 17.6761C114.206 17.6761 115.987 16.9658 117.348 15.5663C118.709 14.1735 119.399 12.3311 119.399 10.0909V0.621094H115.747V10.1388H115.746Z"
      fill="#1D1D1B"
    />
    <path
      d="M138.606 8.80207C138.055 8.43781 137.44 8.14449 136.728 7.90868C136.068 7.69587 135.409 7.50608 134.772 7.34887L132.892 6.89067C132.338 6.75263 131.829 6.59447 131.381 6.41234C131.024 6.27143 130.744 6.09601 130.537 5.8995C130.477 5.83431 130.397 5.74325 130.397 5.66656C130.397 5.43267 130.427 5.21316 130.502 5.00227C130.536 4.8834 130.633 4.75879 130.78 4.63226C130.91 4.51915 131.169 4.35044 131.649 4.18748C132.065 4.04848 132.607 3.98234 133.256 3.98234C133.915 3.98234 134.464 4.04273 134.897 4.17022C136.251 4.5527 136.503 5.23712 136.576 5.79789L136.682 6.65965H140.314L140.263 5.62918C140.187 4.14338 139.558 2.91161 138.403 1.97508C137.189 0.95515 135.496 0.438477 133.378 0.438477C131.279 0.438477 129.65 0.899553 128.543 1.81212C127.38 2.77357 126.788 4.02644 126.788 5.54099C126.788 6.66636 127.139 7.58564 127.828 8.27486C128.429 8.87493 129.173 9.35805 130.045 9.70506C130.85 10.0377 131.731 10.3099 132.658 10.5131C133.505 10.6991 134.306 10.9081 135.048 11.1257C135.706 11.3231 136.25 11.5666 136.663 11.8465C136.898 12.0114 136.992 12.183 136.992 12.4591C136.992 12.9125 136.992 14.1145 133.785 14.1145C132.626 14.1145 131.706 13.9218 131.058 13.547C130.406 13.1674 130.096 12.6901 130.057 11.9961L130.002 11.071H126.239L126.338 12.1456C126.5 13.8528 127.184 15.2054 128.377 16.1572C129.643 17.1647 131.457 17.6756 133.762 17.6756C135.807 17.6756 137.458 17.2472 138.663 16.3921C139.981 15.4661 140.646 14.1212 140.646 12.3948C140.646 10.8918 139.934 9.64179 138.606 8.80207Z"
      fill="#1D1D1B"
    />
    <rect x="148.5" y="0.621094" width="3.65698" height="16.8777" fill="#1D1D1B" />
    <path
      d="M161.273 17.4988H164.922V11.0341H173.011V7.42317H164.922V4.20714H174V0.621094H161.273V17.4988Z"
      fill="#1D1D1B"
    />
    <path
      d="M86.0347 0.597656V4.45785V4.8269V4.82978V9.05232V9.06286V13.2854V17.5175H90.2591V13.2854V9.06286V9.05232V4.82978V4.8269V4.45785V0.597656H86.0347Z"
      fill="#1D1D1B"
    />
    <path d="M91.9658 17.5184H98.696V13.2949L91.9658 17.5184Z" fill="#1D1D1B" />
  </svg>
);

export const StyledRestLuxLogo = styled(LuxLogoFull)(
  ({ theme }) => css`
    position: absolute;
    left: 23px;
    stroke: ${theme.palette.primary.main};

    > * {
      animation: ${fill} 1s forwards;
    }

    &.lux-logo-animate-out > * {
      animation: ${unfill} 0.5s forwards;
    }
  `,
);

const unfill = keyframes`
from {
  fill-opacity: 1;
  stroke-opacity: 1;
}

to {
  fill-opacity: 0;
  stroke-opacity: 0;
}
`;

const fill = keyframes`
from {
  fill-opacity: 0;
  stroke-opacity: 0;
}

to {
  fill-opacity: 1;
  stroke-opacity: 1;
}
`;

export const StyledLogo = styled(LuxLLogo)(
  ({ theme }) => css`
    stroke: ${theme.palette.primary.main};
    padding-left: 23px;
  `,
);
